import React from "react";
// import { useAppStatisticModel } from "../appStatisticModel";
// import { SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";

// const searchFields = [
//     {
//         type: SearchTypeEnum.Input,
//         xxl: 4,
//         span: 4,
//         placeholder: "应用名称",
//         fieldName: "name",
//         size: "small",
//         disabled: false
//     },
//     {
//         type: SearchTypeEnum.Select,
//         xxl: 4,
//         span: 4,
//         placeholder: "所属事业部",
//         fieldName: "code",
//         size: "small",
//         disabled: false,
//         option: []
//     },
//     {
//         type: SearchTypeEnum.Select,
//         xxl: 4,
//         span: 4,
//         placeholder: "所属机构",
//         fieldName: "branch",
//         size: "small",
//         disabled: false,
//         options: []
//     },



// ]

export function PageHeader() {
    // const {
    //     searchParam,
    //     onReset,
    //     onSearch,
    //     updateSearchParam,
    // } = useAppStatisticModel();


    return (
        <YhPageHeader
            title="应用统计"
        // searchValues={searchParam}
        // searchFields={searchFields}
        // onChange={updateSearchParam}
        // handleSearch={onSearch}
        // handleReset={onReset}
        />
    );
}